import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.AUTOMATIONS, app: APP_PATHS.ASSETS });
    context.validatePermissions({ isAllowed, preload });
  },
});
